import { useData } from "./useData";

/**
 * @returns Additional data defined in `data` field.
 */
export const usePageData = <T = object>(): T => {
  const { data } = useData();

  return data as T;
};
